module.exports = __webpack_public_path__ + "static/media/example-alerts.a97bceba.png";